export const API_URL = process.env.REACT_APP_API_URL;
// export const API_URL = "https://api-staging.stylori.com";
export const HOME_PAGE_URL = "";
export const CDN_URL = process.env.REACT_APP_CDN_URL;
// export const CDN_URL = "https://styloriimages.s3.ap-south-1.amazonaws.com/"
export const GOOGLE_CLIENT_ID =
  "410922820159-6r6cbk3aps4icmmc53s11gh5slragib4.apps.googleusercontent.com";
export const FACEBOOK_APP_ID = "238023071773183";
